import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/navbar.css'

import logo from '../img/logo.png'

const Navbar = () => {
    const [expanded, setExpanded] = useState(false);

    const handleNavItemClick = () => {
        setExpanded(false); // Collapse the navbar when an item is clicked
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/" onClick={handleNavItemClick}> <img src={logo} /></Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded={expanded ? "true" : "false"}
                        aria-label="Toggle navigation"
                        onClick={() => setExpanded(!expanded)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`} id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to="/" onClick={handleNavItemClick}>Home</Link>
                            </li>

                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="appointmentDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    About
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="appointmentDropdown">
                                    <li><Link className="dropdown-item" to="/Manish" onClick={handleNavItemClick}>Meet Our Doctor </Link></li>
                                    <li><Link className="dropdown-item" to="/Clinic" onClick={handleNavItemClick}>About Clinic </Link></li>
                                    <li><Link className="dropdown-item" to="/Whychoose" onClick={handleNavItemClick}>Choose Us </Link></li>
                                </ul>


                            </li>

                            {/* Management Dropdown */}
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="managementDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    Services
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="managementDropdown">
                                    <li><Link className="dropdown-item" to="/Endueuro" onClick={handleNavItemClick}>Endo Urology Care </Link></li>
                                    <li><Link className="dropdown-item" to="/Urooncology" onClick={handleNavItemClick}>Uro Oncology Care</Link></li>
                                    <li><Link className="dropdown-item" to="/Kidney" onClick={handleNavItemClick}>Kidney Transplant</Link></li>
                                    <li><Link className="dropdown-item" to="/Female" onClick={handleNavItemClick}>Female Urology Care</Link></li>
                                    <li><Link className="dropdown-item" to="/PediatricUrology" onClick={handleNavItemClick}>Pediatric Urology Carel</Link></li>
                                    <li><Link className="dropdown-item" to="/Reconstructive" onClick={handleNavItemClick}>Reconstructive Urology Care</Link></li>
                                    <li><Link className="dropdown-item" to="/Andrology" onClick={handleNavItemClick}>Andrology Urology Care</Link></li>
                                    <li><Link className="dropdown-item" to="/GeneralUro" onClick={handleNavItemClick}>General Urology Care</Link></li>

                                </ul>

                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/Gallery" onClick={handleNavItemClick}>Gallery</Link>
                            </li>

                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="supportDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    Patient Info
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="managementDropdown">
                                    <li><Link className="dropdown-item" to="/Patientreview" onClick={handleNavItemClick}>Reviews</Link></li>
                                    <li><Link className="dropdown-item" to="/Procedure" onClick={handleNavItemClick}>Procedures</Link></li>

                                </ul>



                            </li>

                            <li className="nav-item">
                                <a
                                    href="tel:+919369996314"
                                    className="btn btn-success"
                                    style={{ borderRadius: '16px', marginLeft: '20px' }}
                                    onClick={handleNavItemClick}
                                >
                                    <i className="fa fa-phone"></i> +91 93699 96314
                                </a>
                            </li>



                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
